import { isEmpty } from "lodash";
// enums
import EResourceType from "@/cms/enums/EResourceType";
// utilities
import { outerNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
// types
import { TMainPageLayoutV3 } from "../type";
import TResource from "@/cms/types/TResource";
import TLanguageVersionDetail from "@/cms/types/TLanguageVersionDetail";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
import ApplicationDocumentSelector from "@/utilities/ApplicationDocumentSelector";
import TApplicationDocument from "@/cms/types/TApplicationDocument";
import CoreDefault from "@/core/Defaults";
import useProgressiveImage from "@/hooks/useProgressiveImage";


type TRender = {
    languageVersion:TLanguageVersionDetail|TLanguageVersionList;
    resources:TResource[];
}

const RenderImage = ( props:TRender ) => {
    const applicationDocument = ApplicationDocumentSelector<TApplicationDocument>({
        resources: props.resources,
        resourceType: EResourceType.INNER_IMAGE,
        type: "find"
    });
    const backgroundImage = applicationDocument?.filePath ? `${CoreDefault.cdn}/${applicationDocument.filePath.replace("\\", "/")}` : null;
    const loaded = useProgressiveImage({ src:backgroundImage });

    return (
        <div className="post-featured-thumb bg-cover" style={loaded?{background: `url('${loaded}')`}:undefined} />
    )
}

const Render = ( props:TRender ) => {
    if ( isEmpty(props.resources.find((item) => item.resourceTypeId === EResourceType.INNER_IMAGE)) ) return null;
    return <RenderImage {...props} />
}

const MNPG036 = ( props:TMainPageLayoutV3 ) => {
    console.log("MNPG036.rendered: ", props);

    if ( !props.params?.["contentDetails"] || isEmpty(props.params?.["contentDetails"]) ) return null;
    const languageVersion = outerNameDescriptionLanguageVersion(props.params["contentDetails"].languageVersions);

    if ( !languageVersion || isEmpty(languageVersion) ) return null;
    return <Render languageVersion={languageVersion} resources={props.params["contentDetails"].resources} />

}

export default MNPG036;
